import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class UnifiedProfileLanguage extends BaseModel {
  static override constructorName = 'UnifiedProfileLanguageModel'

  'language_id': number | null = null
  language: string | null = null
  'knowledge_level_id': number | null = null
  'knowledge_level': string | null = null

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(UnifiedProfileLanguage)
